import type { TenantConfig } from '@/types/TenantConfig'

export const qagoma: TenantConfig = {
  logo: 'assets/qagoma/static/logo.svg',
  themeOptions: {
    dialog: {
      headerTextColor: '#454242',
      headerBackground: '#e2e2e2',
      headerBorder: '1px solid #ffffff',
    },
    mobileFooter: {
      backgroundColor: '#e2e2e2',
      cartButtonBackgroundColor: 'transparent',
      cartButtonBorder: '2px solid #454242',
      cartButtonIconColor: '#454242',
    },
    datePicker: {
      dayTextColor: 'black',
      disabledDayTextColor: '#d0d3db',
    },
  },
  teaserImageSize: {
    width: 320,
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/qagoma/static/images/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
    stripeCreditCard: {
      fontFaceStylesheet: 'assets/qagoma/static/fonts.css',
    },
  },
}
